import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Aircraft from './pages/Aircraft';
import About from './pages/About';
import Contact from './pages/Contact';
import Projects from './pages/Projects';
import FAQ from './pages/FAQ';
import ProfessionalEquipment from './pages/ProfessionalEquipment';
import ITServices from './pages/ITServices';
import Appliances from './pages/Appliances';
import MaintenanceServices from './pages/MaintenanceServices';
import VehiclesLogistics from './pages/VehiclesLogistics';
import EnergySolutions from './pages/EnergySolutions';
import DigitalSolutions from './pages/DigitalSolutions';
import ElectricalInfrastructure from './pages/ElectricalInfrastructure';
import AeronauticalServices from './pages/AeronauticalServices';
import AdminProjects from './pages/AdminProjects';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/professional-equipment" element={<ProfessionalEquipment />} />
              <Route path="/services/it-electronics" element={<ITServices />} />
              <Route path="/services/appliances" element={<Appliances />} />
              <Route path="/services/maintenance" element={<MaintenanceServices />} />
              <Route path="/services/vehicles-logistics" element={<VehiclesLogistics />} />
              <Route path="/services/energy-solutions" element={<EnergySolutions />} />
              <Route path="/services/digital-solutions" element={<DigitalSolutions />} />
              <Route path="/services/electrical-infrastructure" element={<ElectricalInfrastructure />} />
              <Route path="/services/aeronautical" element={<AeronauticalServices />} />
              <Route path="/aircraft" element={<Aircraft />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/projects" element={<AdminProjects />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
